/**
 * URL 根地址规范化工具。
 *
 * 统一处理服务端注入地址、环境变量地址与 window.location.origin：
 * - normalizeUrlBase：去空白、去尾部斜杠，空值返回 ''（便于 `if (base)` 判空）。
 * - trimTrailingSlash：仅去掉末尾的斜杠。
 * - ensureTrailingSlash：规范化后保证末尾恰好一个 '/'。
 */

/** 去掉首尾空白与末尾的全部 '/'，空值统一返回 ''。 */
export function trimTrailingSlash(value: unknown): string {
  if (typeof value !== 'string') return '';
  return value.trim().replace(/\/+$/, '');
}

/**
 * 规范化 URL 根地址：去空白、去尾部斜杠。
 * 输入为空或仅含空白时返回 ''（falsy），便于调用处用 `if (base)` 判空后拼接 `${base}/path`。
 */
export function normalizeUrlBase(value: unknown): string {
  return trimTrailingSlash(value);
}

/** 规范化后保证末尾恰好一个 '/'；空值返回 ''，避免拼出 '//path'。 */
export function ensureTrailingSlash(value: unknown): string {
  const normalized = trimTrailingSlash(value);
  return normalized ? `${normalized}/` : '';
}
